export default "__VITE_ASSET__49e3cc58__"